import { useMemo } from "react";
import { AddableCourse, CourseLite, CourseSummary } from "../../types/course.response";
import { Requirement, Select } from "../../types/requirement.response";
import { getAllCourseOptionsForRequirement } from "../../utils/requirementResponseUtils";
import SidebarAddCourse from "./SidebarAddCourse";
import SidebarCourseSetSlots from "./SidebarCourseSetSlots";

interface SidebarGroupSlotsProps {
    rootNode: Select;
    requirement: Requirement;
    coursesMap: Record<string, CourseSummary>;
    onAdd: (course: AddableCourse, nodeId: string | null) => void | Promise<void>;
    onDelete: (course: CourseLite) => void | Promise<void>;
    isBroad?: boolean;
}

export default function SidebarGroupSlots({ rootNode, requirement, coursesMap, onAdd, onDelete, isBroad }: SidebarGroupSlotsProps) {
    const isFulfilled = rootNode.summary.isFulfilled;

    const allCourses = useMemo(
        () => getAllCourseOptionsForRequirement(requirement, coursesMap),
        [requirement, coursesMap]
    );

    return (
        <div className="mt-2 flex flex-col gap-0.5">
            {rootNode.children.map((child) => {
                if (child.type !== "COURSE_SET") return null;
                return (
                    <SidebarCourseSetSlots
                        key={child.id}
                        courseSet={child}
                        coursesMap={coursesMap}
                        requirementId={requirement.info.id}
                        onAdd={(course) => onAdd(course, child.id)}
                        onDelete={onDelete}
                        idPrefix="sidebar-group"
                        isBroad={isBroad}
                    />
                );
            })}
            {isFulfilled && (
                <SidebarAddCourse
                    allCourses={allCourses}
                    onAdd={(course) => onAdd(course, null)}
                    nodeId={null}
                    dropId={`sidebar-group-slot-${requirement.info.id}-extra`}
                    isBroad={isBroad}
                />
            )}
        </div>
    );
}
